/**
 * С-I3 Р.1 (ACC-B3) — «компания запроса недоступна». Конверт ошибки сервера кладёт код в
 * `details.code`: `{ code: 'auth.forbidden', details: { code: 'ENTITY_FORBIDDEN', … } }` —
 * `forbidden()` бэкенда отдаёт общий `auth.forbidden`, а уточнение уходит в детали. Сравнение
 * `err.code === 'ENTITY_FORBIDDEN'` (С-I2 Р.3) живьём не срабатывало никогда: тест мокал код
 * верхним уровнем. Верхний уровень принимается тоже — на случай прямого кода.
 */
export function isEntityForbidden(err: unknown): boolean {
  if (!err || typeof err !== 'object') return false;
  const e = err as { status?: unknown; code?: unknown; details?: { code?: unknown } };
  if (e.status !== 403) return false;
  return e.code === 'ENTITY_FORBIDDEN' || e.details?.code === 'ENTITY_FORBIDDEN';
}
